type Emit = (name: string, params: Record<string, unknown>) => void;
type CalendarMessage = Pick<MessageEvent, 'origin' | 'source' | 'data'>;

export function trackCalendlyMessage(event: CalendarMessage, frame: Window | null | undefined,
  pathname: string, seen: Set<string>, emit: Emit, pixelLead: () => void): boolean {
  if (event.origin !== 'https://calendly.com' || !frame || event.source !== frame) return false;
  const name = event.data?.event;
  const events: Record<string, string> = {
    'calendly.event_type_viewed': 'calendar_view',
    'calendly.date_and_time_selected': 'time_selected',
    'calendly.event_scheduled': 'call_scheduled',
  };
  if (!Object.prototype.hasOwnProperty.call(events, name) || seen.has(name)) return false;
  seen.add(name);
  const source = pathname.replace(/\/+$/, '') || '/';
  const prefix = source === '/book' ? 'book' : 'contact';
  emit(prefix + '_' + events[name], { source, send_to: 'G-EM7QLQLR4K' });
  if (name === 'calendly.event_scheduled') {
    emit('ads_conversion_Book_appointment_Page_1_1', {});
    emit('generate_lead', { lead_type: 'booked_call', source, send_to: 'G-EM7QLQLR4K' });
    pixelLead();
  }
  return true;
}
